export enum EAgentPostQueryKey {
  AGENT_ADD_POST = 'agent-add-post',
  AGENT_LIST_POSTS = 'agent-list-posts',
}
